import { DefaultRequest } from 'scripts/api';

/* Model */
class HOSGeoTabSyncLogModel extends App.Models.BaseModel {}

App.Models.HOSGeoTabSyncLog = HOSGeoTabSyncLogModel;

/* Collection */
class HOSGeoTabSyncLogCollection extends App.Collections.BaseCollection {
  url = "GeotabSyncHOS/logs";
  model = App.Models.HOSGeoTabSyncLog;
}

App.Collections.HOSGeoTabSyncLogs = HOSGeoTabSyncLogCollection;

/* Router */
class HOSGeoTabSyncLogRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "HOSGeoTabSyncLog";
    const model = App.Models.HOSGeoTabSyncLog;
    const collectionClass = App.Collections.HOSGeoTabSyncLogs;

    super(entityName, model, collectionClass);
  }

  beforeInitializeGrid = (form, pageLayout) => {
    const formCopy = form;
    const entity = App.Objects.HOSGeoTabSyncLog.entityName;
    formCopy.initializeGrid = () => {
      const grid = new Monet.Builder.Form.Grid(pageLayout, entity);
      grid.getColumnsByGridLayout = () =>
        Monet.Grid.getGridLayout(pageLayout, entity).map(item => {
          const column = item;
          column.sortable = false;
          return column;
        });
      grid.getGridOptions = () => ({
        entity,
        columnCheckBox: {
          show: false
        },
        columnEdit: {
          show: false
        },
        actions: ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS"],
        gridActionsSelector: grid.gridActionsSelector,
        entityToActionGrid: entity,
        gridContainner: grid.gridContainerSelector,
        multiColumnSort: false,
        multiSelect: false,
        frozenColumn: Monet.Grid.getIndexFrozenColumn(pageLayout)
      });
      grid.show();
    };
  };

  requestToGetData = (updateGrid = false) => {
    const form = App.Forms.HOSGeoTabSyncLog;
    const filterBuilder = form.filterBuilder;
    const columns = form.table.getColumns();
    const filter = filterBuilder.selectedFilters;
    const body = {
      firstResult: App.Forms.HOSGeoTabSyncLog.pagination.first,
      maxResult: 51
    };
    for (const key in filter) {
      if (key === "createdDate_Range") {
        const initialDate = filter[key].value.ini;
        const finalDate = filter[key].value.fin;
        if (initialDate && finalDate) {
          body.fromDate = initialDate;
          body.toDate = finalDate;
        }
      } else if (key === "createdDate") {
        const initialDate = filter[key].value;
        const finalDate = filter[key].value;
        if (initialDate && finalDate) {
          body.fromDate = initialDate;
          body.toDate = finalDate;
        }
      } else if (key.indexOf(".") !== -1) {
        key.split(".").forEach((prop, index, array) => {
          const previousProp = array[index - 1];
          if (body[previousProp]) {
            body[previousProp][prop] =
              index === array.length - 1 ? filter[key].value : {};
          } else {
            body[prop] = {};
          }
        });
      } else {
        const { value } = filter[key];
        if (value) {
          body[key] = filter[key].value;
        }
      }
    }
    const request = new DefaultRequest({
      data: body,
      url: App.Objects.HOSGeoTabSyncLog.collection.url,
      method: "post",
      success: data => {
        const parsedData = data || [];
        const firstIndex = App.Forms.HOSGeoTabSyncLog.pagination.first;
        const result = parsedData.map((item, index) => {
          const log = item;
          log.id = firstIndex + index;
          return log;
        });
        filterBuilder.loading.hide();
        if (typeof updateGrid === "boolean") {
          Monet.Grid.appendDataToGridAfterPagination(
            App.Objects.HOSGeoTabSyncLog.entityName,
            columns,
            new App.Collections.HOSGeoTabSyncLogs(result)
          );
        } else {
          Monet.Grid.addDataToGrid(
            App.Objects.HOSGeoTabSyncLog.entityName,
            columns,
            new App.Collections.HOSGeoTabSyncLogs(result),
            true
          );
        }
      },
      error: () => {
        filterBuilder.loading.hide();
      }
    });
    request.send();
  };

  beforeList = () => {
    const filterBuilder = App.Forms.HOSGeoTabSyncLog.filterBuilder;
    filterBuilder.setDefaultFilters({
      createdDate: {
        value: new Date().toJSON().match(/(\d{4})-\d{2}-\d{2}/)[0]
      }
    });
    filterBuilder.customRequest = App.Objects.HOSGeoTabSyncLog.requestToGetData;
  };

  updateGrid = () => {
    App.Forms.HOSGeoTabSyncLog.filterBuilder.customRequest(true);
  };
}

App.Routers.HOSGeoTabSyncLog = HOSGeoTabSyncLogRouter;
